var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5521 8.552L20.7814 4.78133C20.2814 4.28133 19.6027 4 18.8961 4H9.33341C7.86008 4 6.66675 5.19333 6.66675 6.66667V25.3333C6.66675 26.8067 7.86008 28 9.33341 28H22.6667C24.1401 28 25.3334 26.8067 25.3334 25.3333V10.4373C25.3334 9.73067 25.0521 9.052 24.5521 8.552V8.552Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3334 10.6667H20.0001C19.2641 10.6667 18.6667 10.0693 18.6667 9.33333V4",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7869 22.0667H18.2135",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4441 17.0013V15.444C14.4441 15.0146 14.7921 14.6666 15.2214 14.6666H16.7788C17.2081 14.6666 17.5561 15.0146 17.5561 15.444V17.0013C17.5561 17.4306 17.2081 17.7786 16.7788 17.7786H15.2214C14.7921 17.7773 14.4441 17.4293 14.4441 17.0013Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 23.2226V21.6653C10.6667 21.2359 11.0147 20.8879 11.4441 20.8879H13.0014C13.4307 20.8879 13.7787 21.2359 13.7787 21.6653V23.2226C13.7787 23.6519 13.4307 23.9999 13.0014 23.9999H11.4441C11.0147 23.9999 10.6667 23.6519 10.6667 23.2226Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2227 23.2226V21.6653C18.2227 21.2359 18.5707 20.8879 19 20.8879H20.5573C20.9867 20.8879 21.3347 21.2359 21.3347 21.6653V23.2226C21.3333 23.6519 20.9853 23.9999 20.556 23.9999H18.9987C18.5707 23.9999 18.2227 23.6519 18.2227 23.2226H18.2227Z",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9867 20.8934L16.9734 17.7467",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0134 20.8934L15.0268 17.7467",
    stroke: "#989898",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileWhite);
export default __webpack_public_path__ + "static/media/file-white.92e8f8479c24da9ceb9e84bb2b2d0cd9.svg";
export { ForwardRef as ReactComponent };